const { generateKeywordsQueryForOr } = require('@smarttransit/common')

const BUS_STOP_SORT_ORDERS = {
  name_asc: 'name ASC',
  name_desc: 'name DESC',
  otp_name_asc: 'externalName ASC',
  otp_name_desc: 'externalName DESC',
  date_updated_asc: 'dateUpdated ASC',
  date_updated_desc: 'dateUpdated DESC'
}

function appendKeywordFilter (and, searchKeywords) {
  if (!searchKeywords || !searchKeywords.trim()) {
    return
  }

  and.push({ or: generateKeywordsQueryForOr(searchKeywords, ['name', 'externalName']) })
}

function appendAudioFilter (and, audioBusStopIds) {
  if (!audioBusStopIds || !audioBusStopIds.length) {
    return
  }

  and.push({ id: { inq: audioBusStopIds } })
}

function uniqueBusStopIds (records) {
  const seen = {}
  const ids = []
  const source = records || []

  for (let i = 0; i < source.length; i++) {
    const record = source[i]
    const id = record && record.busStopId
    if (id == null || seen[id]) {
      continue
    }

    seen[id] = true
    ids.push(id)
  }

  return ids
}

function buildBusStopSearchFilter ({ page, rowsPerPage, routerId, searchKeywords, selectedSortFilter, audioBusStopIds }) {
  const offset = page === 1 ? 0 : (page * rowsPerPage) - rowsPerPage
  const and = [{ routerId }]

  appendKeywordFilter(and, searchKeywords)
  appendAudioFilter(and, audioBusStopIds)

  const filter = {
    limit: rowsPerPage,
    offset,
    where: { and }
  }

  const order = BUS_STOP_SORT_ORDERS[selectedSortFilter]
  if (order) {
    filter.order = order
  }

  return filter
}

module.exports = {
  BUS_STOP_SORT_ORDERS,
  uniqueBusStopIds,
  buildBusStopSearchFilter
}
